//Library
import React, { Component } from 'react';
import Swal from 'sweetalert2';
import Select from 'react-select';
import { pushUserIdToDataLayer } from '../../utils/analytics.js';

class Step1 extends Component {
    constructor(props) {
        super(props);
        this.selectRef = undefined;
        this.state = {
            marketingList: undefined,
            fundList: [],
            mktID: undefined,
            funds: [],
            ratio: 0,
            mktName: undefined,
            gdName: undefined,
            context: undefined,
            keyWordOption: [],
            selectKeyWord: [],
        }
    }

    componentWillMount() {
        pushUserIdToDataLayer();  //登入
        this.setState({ funds: this.props.marketingList[0].funds, mktID: this.props.marketingList[0].mktID, ratio: this.props.marketingList[0].ratio, mktName: this.props.marketingList[0].mktName, keyWordOption: this.getKeyWordArr(this.props.marketingList[0].funds) });
    }

    changeSelect(mktID, funds, ratio, mktName) {
        for (let j = 0; j <= document.getElementsByClassName("tab2").length - 1; j++) {
            let classname = document.getElementsByClassName("tab2")[j].getAttribute("class").replace("active", "").trim();
            document.getElementsByClassName("tab2")[j].setAttribute("class", classname);
        }
        document.getElementsByClassName(mktID)[0].setAttribute("class", "nav-link tab2 " + mktID + " active");
        this.setState({ funds: funds, mktID: mktID, ratio: ratio, mktName: mktName, keyWordOption: this.getKeyWordArr(funds), selectKeyWord: "" });
        this.selectRef.select.clearValue();
    }

    chkSelectFundID(fundID) {
        if (this.state.fundList.length === 0) {
            return false
        } else {
            for (let i = 0; i <= this.state.fundList.length - 1; i++) {
                if (this.state.fundList[i].fundID === fundID)
                    return true;
            }
            return false;
        }
    }

    radioSelect(evt) {
        let fundsList = [];
        let fundID = evt.target.value;
        let shortName = evt.target.getAttribute("data-shortname");
        let intro = evt.target.getAttribute("data-intro");
        if (this.state.fundList.length === 0) {
            fundsList.push({ fundID: fundID, shortName: shortName, intro: intro, mktID: this.state.mktID, percent: this.state.ratio, mktName: this.state.mktName });
            this.setState({ fundList: fundsList });
        } else {
            for (let i = 0; i <= this.state.fundList.length - 1; i++) {
                if (this.state.fundList[i].mktID !== this.state.mktID)
                    fundsList.push(this.state.fundList[i]);
            }
            fundsList.push({ fundID: fundID, shortName: shortName, intro: intro, mktID: this.state.mktID, percent: this.state.ratio, mktName: this.state.mktName });
            this.setState({ fundList: fundsList });
        }

    }

    clickSubmit() {

        if (this.state.fundList.length === this.props.marketingList.length) {
            this.props.goStep2(this.state.fundList);
        } else {
            let marketingList2 = JSON.parse(JSON.stringify(this.props.marketingList));
            let msg = "";
            for (let j = 0; j <= this.state.fundList.length - 1; j++) {
                for (let i = 0; i <= marketingList2.length - 1; i++) {
                    if (marketingList2[i] !== undefined && marketingList2[i].mktID === this.state.fundList[j].mktID) {
                        delete marketingList2[i];
                    }
                }
            }
            for (let k = 0; k <= marketingList2.length - 1; k++) {
                if (marketingList2[k] !== undefined) {
                    msg += marketingList2[k].mktName + " ";
                }
            }
            Swal.fire("尚未完成", "投資組合 " + msg + "尚有基金未選擇，請確認後再送出。");
        }
    }

    prevBtn() {
        document.documentElement.scrollTop = 0;
        let mktIndex = this.props.marketingList.findIndex((item, i) => {
            return item.mktID === this.state.mktID;
        });
        if (mktIndex !== 0) {
            mktIndex--;
            let { mktID, funds, ratio, mktName } = this.props.marketingList[mktIndex];
            this.changeSelect(mktID, funds, ratio, mktName);
        } else {
            this.props.backStep0();
        }
    }

    findIndexWithIE() {
        for (let i = 0; i <= this.props.marketingList.length - 1; i++) {
            if (this.props.marketingList[i].mktID === this.state.mktID) {
                return i;
            }
        }
    }

    nextBtn() {
        //因為破IE 沒辦法
        // let mktIndex = this.props.marketingList.findIndex((item, i) => {
        //     return item.mktID === this.state.mktID;
        // });
        document.documentElement.scrollTop = 0;
        let mktIndex = this.findIndexWithIE();
        if (mktIndex === this.props.marketingList.length - 1) {
            this.clickSubmit();
        } else {
            mktIndex++;
            let { mktID, funds, ratio, mktName } = this.props.marketingList[mktIndex];
            this.changeSelect(mktID, funds, ratio, mktName);

        }
    }

    getKeyWordArr(funds) {
        let arr = [];
        funds.filter((value) => {
            if (arr.map((value) => { return value.value }).join("|").indexOf(value.keyWord) === -1) {
                arr.push({ value: value.keyWord, label: value.keyWord });
            }
            return value;
        })
        return arr;
    }

    render() {
        return <div className="anueContainer combinationContainer">
            <div className="combinationSub">選購您的投資組合</div>
            <div className="combinationTitle">
                <div className="titleFont">{this.props.gdName}</div>
            </div>
            <div className="tab-content" id="mainTabContent">
                <div className="tab-pane fade show active" id="mainTab0" role="tabpanel">
                    <ul className="nav nav-tabs anueSubTabs" id="subTab" role="tablist">
                        {
                            this.props.marketingList !== undefined ?
                                this.props.marketingList.map(({ mktID, mktName, ratio, funds }, index) => {
                                    return <li className="nav-item" style={{ flex: (this.props.marketingList.length === 3) ? "1 1 30%" : "1 1 50%" }} onClick={(evt) => { this.changeSelect(mktID, funds, ratio, mktName) }} id={mktID} key={mktID + index}>
                                        <span className={"nav-link " + (index === 0 ? "active tab2" : "tab2") + " " + mktID} id="subTab00_tab" data-toggle="tab" role="tab" aria-controls="subTab00" aria-selected="true">
                                            <div className="combinationName">
                                                <h5 style={{ whiteSpace: "nowrap" }}>{mktName}</h5>
                                                <div className="tag">{ratio * 100}%</div>
                                            </div>
                                        </span>
                                    </li>
                                }) : ""
                        }
                    </ul>
                    <div className="tab-content" id="subTabContent">
                        <div className="tab-pane fade show active">
                            <div className="fundSelects">
                                <Select placeholder={"請選擇基金品牌(可複選)"} ref={ref => { this.selectRef = ref }} options={this.state.keyWordOption} isMulti={true} onChange={(value) => { this.setState({ selectKeyWord: value.map(({ value }) => { return value }) }) }} />
                            </div>
                            <div className="fundSelects">
                                {
                                    this.state.funds !== undefined ?
                                        this.state.funds.map(({ fundID, shortName, intro, keyWord }, index) => {
                                            if (this.state.selectKeyWord.length !== 0 && this.state.selectKeyWord.filter((value) => { return value !== keyWord }).length === this.state.selectKeyWord.length) return "";
                                            let isSelect = this.chkSelectFundID(fundID);
                                            return <div className="form-check" key={Math.floor(Math.random() * (99999999 - 10000000)) + 1}>
                                                {
                                                    isSelect === false ?
                                                        <input className="form-check-input" id={"subTab00_" + index} type="radio" name="subTab00_Set" data-shortname={shortName} data-intro={intro} value={fundID} onClick={(evt) => { this.radioSelect(evt) }} /> :
                                                        <input className="form-check-input" id={"subTab00_" + index} type="radio" name="subTab00_Set" data-shortname={shortName} data-intro={intro} value={fundID} defaultChecked onClick={(evt) => { this.radioSelect(evt) }} />
                                                }
                                                <label className="form-check-label" htmlFor={"subTab00_" + index}><span>
                                                    <div className="checkmark"></div></span><span>
                                                        <h3>{"（" + fundID + "）" + shortName}</h3>
                                                        <p>{intro}</p></span></label>
                                            </div>
                                        }) : ""
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {
                <div className="buttonContainer">
                    <button className="btn btn-third round" id="prevBtn" onClick={() => { this.prevBtn() }}>上一步</button>
                    <button className="btn btn-primary round main" id="nextBtn" onClick={() => { this.nextBtn() }}>下一步</button>
                </div>
            }

        </div>
    }
}
export default Step1;